import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getWorkOrderItemsCompleted = {
  name: "getWorkOrderItemsCompleted" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
